import React, { useState } from "react";
import Layout from "./layout";

import FormHeader from "../components/FormHeader";
import FileUploadComponent from "../components/FileUploadComponent";
import SelectComponent from "../components/SelectComponent";
import Aetextarea from "../components/Aetextarea";
import TextInput from "../components/TextInput";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PhoneInput from "../components/PhoneInput";
import TagInput from "../components/TagInput";
import TabComponent from "../components/InventaryPanel";
import DateInput from "../components/DateInput";

const AddNewCustomer = () => {
    const [fileData, setFileData] = useState(null);
    const [message, setMessage] = useState("");
    const [selectedSingle, setSelectedSingle] = useState("");
    const [isCustomerModalOpen, setCustomerModalOpen] = useState(false);

    // Handle caption change
    const handleCaptionChange = (text) => {
        setMessage(text);
    };

    const handleTextInputChange = (value) => {
        console.log("TextInput:", value);
    };

    const handleFileChange = (file, isValid) => {
        console.log("Selected file:", file);
        console.log("Is valid:", isValid);
        setFileData(file);
    };

    const options = [
        { value: "1", label: "Option 1" },
        { value: "2", label: "Option 2" },
        { value: "3", label: "Option 3" },
        { value: "4", label: "Option 4" },
    ];

    const handleTagsChange = (tags) => {
        console.log("Selected Tags:", tags);
    };
    const availableTags = [
        "JavaScript",
        "HTML",
        "CSS",
        "React",
        "Node.js",
        "Angular",
        "Vue",
        "Python",
        "Django",
        "Flask",
    ];

    return (
        <Layout>
            <FormHeader title="Add New Customer" backUrl="/Customer" closeUrl="/" />
            <Row>
                <Col md={7}>
                    <div className="form_section">
                        <h6 className="card-title">Customer Details</h6>
                        <Row>
                            <Col md>
                                <TextInput
                                    label="First Name"
                                    placeholder="First Name"
                                    required={true}
                                    onChange={handleTextInputChange}
                                />
                            </Col>
                            <Col md>
                                <TextInput
                                    label="Last Name"
                                    placeholder="Last Name"
                                    required={true}
                                    onChange={handleTextInputChange}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <SelectComponent
                                label="Language"
                                placeholder="English(Default)"
                                options={options}
                                isMulti={false}
                                onChange={setSelectedSingle}
                            />
                        </Row>
                        <Row>
                            <Col md>
                                <SelectComponent
                                    label="Gender"
                                    options={options}
                                    isMulti={false}
                                    onChange={setSelectedSingle}
                                />
                            </Col>
                            <Col md>
                                <DateInput
                                    label="Date of Birth"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md>
                                <PhoneInput
                                    label="Mobile Number"
                                    placeholder="Enter your mobile number"
                                />
                            </Col>
                            <Col md>
                                <TextInput
                                    label="Email"
                                    placeholder="Email"
                                    required={true}
                                    onChange={handleTextInputChange}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <label><input type="checkbox" /> Customer agreed to receive emails</label>
                            <label><input type="checkbox" /> Customer agreed to receive text SMS</label>
                        </Row>
                    </div>
                    <div className="form_section">
                        <h6 className="card-title">Location Details</h6>
                        <TextInput
                            label="Address"
                            placeholder="Address"
                            required={true}
                            onChange={handleTextInputChange}
                        />
                        <div className="row">
                            <div className="col-md-6">
                                <TextInput
                                    label="Street"
                                    placeholder="Street"
                                    required={true}
                                    onChange={handleTextInputChange}
                                />
                            </div>
                            <div className="col-md-6">
                                <TextInput
                                    label="City"
                                    placeholder="City"
                                    required={true}
                                    onChange={handleTextInputChange}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <TextInput
                                    label="State"
                                    placeholder="State"
                                    required={true}
                                    onChange={handleTextInputChange}
                                />
                            </div>
                            <div className="col-md-6">
                                <TextInput
                                    label="Postal Code"
                                    placeholder="Code"
                                    required={true}
                                    onChange={handleTextInputChange}
                                />
                            </div>
                        </div>
                        <SelectComponent
                            label="Delivery Zone"
                            name="Recurrence"
                            options={options}
                            isMulti={false}
                            onChange={setSelectedSingle}
                        />
                    </div>
                </Col>

                <Col md={5}>
                    <div className="form_section">
                        <h6 className="card-title">Tax Exemption</h6>
                        <Row>
                            <label><input type="checkbox" /> Collect Tax</label>
                        </Row>

                    </div>

                    <div className="form_section">
                        <h6 className="card-title">Note</h6>
                        <Row>
                            <small>Write here...</small>
                        </Row>

                    </div>
                    
                    <div className="form_section">
                        <h6 className="card-title">Assign Tag</h6>

                        <div className="row">
                            <div className="col p-3">
                                <a
                                    className="search-input-wrapper"
                                    onClick={() => setCustomerModalOpen(true)}
                                >
                                    <div className="ae-search-container">
                                        <i class="bi bi-search"></i> Search Tags
                                    </div>
                                </a>
                            </div>
                        </div>

                        <div className="tags">
                            <button className="tag">Tag 1  ✕</button>
                            <button className="tag">Tag 2  ✕</button>
                        </div>
                    </div>

                </Col>
            </Row>
        </Layout >
    );
};

export default AddNewCustomer;
